<template>
  <th @click="clicked"
      class="sortHeader noselect right"
      role="columnheader"
      slot-scope="col"
      :aria-sort="ariaSort"
      :aria-disabled="ariaDisabled"
      v-show="this.isVisible"
      v-bind:style="{ width: column.width?column.width:'auto;' }">
    <i v-if="column.isSortable" :class="[getSortClass(column)]"></i>
    <i v-if="column.isBotton" :class="column.iconClass"></i>
    <span>{{ label }}</span>
  </th>
</template>
<script>
  export default {
    name: 'VueHeader',
    props: ['column', 'sort', 'options'],
    computed: {
      ariaDisabled () {
        if (!this.column.isSortable) {
          return 'true'
        }
        return false
      },
      ariaSort () {
        if (!this.column.isSortable) {
          return false
        }
        if (this.column.fieldName !== this.sort.fieldName) {
          return 'none'
        }
        return this.sort.order === 'asc' ? 'ascending' : 'descending'
      },
      isVisible () {
        // options: { showDefault: false, activeFilter: 'Toners' },
        if (this.column.isHidden) {
          return false
        }
        if (this.column.filterKey) {
          if (this.options.activeFilter === this.column.filterKey || this.options.activeFilter === 'All') {
            return true
          } else {
            return false
          }
          // return !this.column.isHidden
        } else {
          return true
        }
      },
      label () {
        if (this.column.label === null) {
          return this.column.fieldName
        }
        return this.column.label
      }
    },
    methods: {
      getSortClass (column) {
        let sortFieldName = ''
        if (column.sortFieldName) {
          sortFieldName = column.sortFieldName
        } else {
          sortFieldName = column.fieldName
        }
        let sortClass = 'fa '
        if (this.sort.fieldName === sortFieldName) {
          sortClass += 'iconBlack fa fa-sort-' + this.sort.order
        } else {
          sortClass += 'iconGray fa fa-sort'
        }
        return sortClass
      },
      clicked () {
        this.$emit('click', this.column)
      },
      clicked_Old () {
        if (this.column.isSortable || this.column.isBotton) {
          this.$emit('click', this.column)
        }
      }
    }
  }
</script>
<style>
  th {
    background-color: #ecf0f5;
    z-index: 1000;
  }
</style>



// WEBPACK FOOTER //
// TableHeader.vue?811c6e94